var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeach = function SvgBeach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m16.94 4.345-.201-.102C12.297 2.126 7.227 3.247 5.167 7.01a.78.78 0 0 0 .299 1.052l15.385 8.635a.76.76 0 0 0 1.039-.302c2.033-3.714.358-8.581-3.653-11.296l.415-.729a.75.75 0 1 0-1.304-.742zM2 20.25a.75.75 0 0 0 0 1.5h5.821c.119.03.242.029.357 0H22a.75.75 0 0 0 0-1.5H9.303l3.349-5.879a.75.75 0 0 0-1.304-.742L7.576 20.25z"
  })));
};
export default SvgBeach;